let filterDict = (value, option) => {
    if (option) {
        try {
            var arr = []
            arr = option.filter((el) => {
                return el.dictValue == value;
            })
            const str = arr[0].dictLabel
            return str
        } catch (error) {

        }
    }

}
let phoneFormat = (s) => { // s表示传入的参数

    if (s !== '' || s !== null || s !== undefined) {
        if (s) {
            if (s.substring(0, 1) == 8) {

                return 0 + s
            } else { return s }
        }
    }



}

let quantileMoney = (num) => {
    if(num && num!=null){  
        num = String(num);  
        var left=num.split('.')[0],right=num.split('.')[1];  
        right = right ? (right.length>=2 ? '.'+right.substr(0,2) : '.'+right+'0') : '';  
        var temp = left.split('').reverse().join('').match(/(\d{1,3})/g);  
        return (Number(num)<0?"-":"") + temp.join(',').split('').reverse().join('')+right;  
    }else if(num===0){   //注意===在这里的使用，如果传入的num为0,if中会将其判定为boolean类型，故而要另外做===判断  
        return '0';  
    }else{  
        return "0";  
    }  
  
}

export default { filterDict, phoneFormat,quantileMoney }



// WEBPACK FOOTER //
// ./src/utils/filter/filter.js